import CaptainApiToolsAPI from 'dashboard/api/captain/apiTools';
import { createStore } from './storeFactory';

export default createStore({
  name: 'CaptainApiTool',
  API: CaptainApiToolsAPI,
});
